module.exports = __webpack_public_path__ + "img/icon_recruit_welfare_06.6ababf38.png";